module.exports = __webpack_public_path__ + "img/trip_19.e839578b.jpg";